import styled from "styled-components";

export const AppForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 70%;
  margin-left: 15%;
  height: auto;
  text-align: center;

  @media (max-width: 768px) {
    width: 85%;
    margin-left: 7.5%;
  }

  &.scrollable {
    display: block;
    text-align: center;
  }

  animation: form-in 0.6s ease-in-out;
  @keyframes form-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;
